import { StyleSheet } from 'react-native';

import { Color, FontFamily, FontSize, Padding } from '@/styles/GlobalStyles';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    gap: 1,
    width: '100%',
    flex: 1,
    alignItems: 'flex-start',
  },
  rows: {
    flexDirection: 'row',
    width: '100%',
  },
  headerCells: {
    backgroundColor: Color.primary[300],
    paddingVertical: 13,
    paddingHorizontal: Padding.p_5xs,
    height: 40,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    boxSizing: 'border-box',
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: Color.gray[100],
  },
  headerCellId: {
    width: 70,
    borderTopLeftRadius: 8,
  },
  headerCellStatus: {
    borderTopRightRadius: 8,
    borderRightWidth: 0,
  },
  text: {
    color: Color.gray.white,
    fontFamily: FontFamily.medium,
    textTransform: 'capitalize',
    lineHeight: 16,
    fontSize: FontSize.sm,
    textAlign: 'center',
    flex: 1,
  },
  paginationContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: 16,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: Color.gray[100],
  },
  paginationText: {
    color: Color.gray[300],
    fontFamily: FontFamily.regular,
    fontSize: FontSize.sm,
  },
  paginationControls: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  pageButton: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: Color.gray[50],
    borderWidth: 1,
    borderColor: Color.gray[100],
  },
  disabledButton: {
    opacity: 0.5,
  },
  itemsPerPageContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  selectTrigger: {
    backgroundColor: Color.gray[50],
    borderWidth: 1,
    borderColor: Color.gray[100],
    borderRadius: 8,
    padding: 8,
    minWidth: 60,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
